import request from '../../utils/request'

export function fetchList (data) {
  return request.post('/business/ordersRefund/page', data, {
    trim: true
  })
}

export function getById (id) {
  return request.get(`/business/ordersRefund/${id}`)
}

export function retryRefund (id) {
  return request.post(`/business/ordersRefund/retryRefund/${id}`)
}
export function exportExcel (data) {
  return request.post('/business/ordersRefund/exportExcel', data, {
    download: true,
    trim: true
  })
}
